/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../../../common/components/layout/Layout';
import Header from '../../../../common/components/layout/Header';
import LayoutInside from '../../../../common/components/layout/LayoutInside';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { answerChallenge, fetchDefyById, resetStateDefyResponse } from '../../../../modules/sport/actions/reducerDefy';
import Loading from '../../../../common/loading/Loading';
import { format } from 'date-fns';
import MsjSuccess from '../../../../common/components/sections/MsjSuccessDefy';
import { attributesBySport } from '../../../../common/data/attributes';
import { useAuth } from '../../../../context/auth-context';
import Defy from '../../../../common/components/sections/Defy';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Challenge = (): JSX.Element => {
    const auth = useAuth();

    const attribute = attributesBySport('defy');
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const query = useQuery();
    const [title, setTitle] = useState<string>();
    const [error, setError] = useState<string>('');
    const [errorDefy, setErrorDefy] = useState<string>('');
    const challengeId = query.get('challengeId');
    const selectDefy = (state: any) => state.defy;
    const defy = useSelector(selectDefy);
    const selectDefyResponse = (state: any) => state.defyResponse;
    const defyResponse = useSelector(selectDefyResponse);
    const [detDefy, setDetDefy] = useState<any | null>(null);
    const [statusCancel, setStatusCancel] = useState(false);
    const [statusDefy, setStatusDefy] = useState(false);
    const [participate, setParticipate] = useState(false);
    const [dateMatch, setDateMatch] = useState({ start: '', end: '', date: '', format: '', club: '' });
    const day = query.get('day');
    const region = query.get('region');
    const commune = query.get('commune');
    const [timeDefy, setTimeDefy] = useState(false);
    const mydate = new Date();
    const [declineDefy, setCancelSuscription] = useState<string>('inactive');
    const [statusDecline, setStatusDecline] = useState(false);

    const pathnameDefys = `/${sport}/desafiar/equipos/filter`;

    const pathnameAll = window.location.pathname + useLocation().search;

    const [breads, setBreads] = useState([
        {
            key: 'desafiar',
            name: 'Desafíar | Buscar',
            url: `/integrar`,
            add: true,
        },
        {
            key: 'equipos',
            name: 'Equipos',
            url: pathnameDefys,
            add: false,
        },
        {
            key: 'responder',
            name: 'Responser',
            url: pathnameAll,
            add: false,
        },
    ]);

    useEffect(() => {
        setDetDefy(null);
        dispatch(resetStateDefyResponse());
        if (challengeId) {
            dispatch(fetchDefyById(challengeId, auth.isLoggedIn, 'challengeDetail'));
        }
    }, [challengeId]);

    useEffect(() => {
        if (day || region || commune) {
            const pathQuery = `?region=${region}&commune=${commune}&day=${day}`;

            const pathnameDefys = `/${sport}/desafiar/equipos/filter${(day || region || commune) && pathQuery}`;

            setBreads([
                {
                    key: 'desafiar',
                    name: 'Desafíar | Buscar',
                    url: `/integrar`,
                    add: true,
                },
                {
                    key: 'equipos',
                    name: 'Equipos',
                    url: pathnameDefys,
                    add: false,
                },
                {
                    key: 'responder',
                    name: 'Responser',
                    url: pathnameAll,
                    add: false,
                },
            ]);
        }
    }, [day, region, commune]);

    useEffect(() => {
        console.log(defy);
        if (defy) {
            if (defy.error) {
                // console.log('aqui error');
                setErrorDefy('Error al obtener los recursos para este desafío');
            } else if (defy.data && defy.data.data && defy.data.statusCode === 'CHALLENGES_BY_ID') {
                setStatusCancel(false);
                const newDefy = defy.data.data;
                setDetDefy(newDefy);
            } else if (defy.data && defy.data.data && defy.data.statusCode === 'CHALLENGES_NOT_FOUND') {
                setError('Error al obtener los recursos para este desafío');
            }
        }
    }, [defy]);

    useEffect(() => {
        //console.log({ defyResponse });
        if (defyResponse) {
            if (defyResponse.error) {
                setError(defyResponse.error);
            } else if (defyResponse.data?.statusCode === 'CHALLENGES_ACCEPTED_SUCCESS') {
                setStatusDefy(true);
            } else if (defyResponse.data?.statusCode === 'CHALLENGES_REJECTED_SUCCESS') {
                //console.log('aqui llegue *************** CHALLENGES_REJECTED_SUCCESS');
                setStatusDecline(true);
            }
        }
    }, [defyResponse]);

    useEffect(() => {
        if (detDefy && detDefy.reservation && detDefy.reservation.start) {
            const regionId = detDefy.reservation.field?.club?.regionId;
            const countyId = detDefy.reservation.field?.club?.countyId;
            /*const capacityTeam =
                detDefy.reservation.field?.capacity > 0 ? Math.round(detDefy.reservation.field?.capacity / 2) : '';
            const capacity = ` ${capacityTeam}x${capacityTeam} `;*/
            if (!(day || region || commune)) {
                const pathnameDefys = `/${sport}/desafiar/equipos/filter?region=${regionId}&commune=${countyId}`;

                setBreads([
                    {
                        key: 'desafiar',
                        name: 'Desafíar | Buscar',
                        url: `/integrar`,
                        add: true,
                    },
                    {
                        key: 'equipos',
                        name: 'Equipos',
                        url: pathnameDefys,
                        add: false,
                    },
                    {
                        key: 'responder',
                        name: 'Responser',
                        url: pathnameAll,
                        add: false,
                    },
                ]);
            }
            // format: detDefy.reservation.field.format?.name || '', activar cuando me avisen
            setDateMatch({
                start: format(new Date(detDefy.reservation?.start), "H':'mm"),
                date: format(new Date(detDefy.reservation.start), "dd'-'MM'-'Y"),
                end: format(new Date(detDefy.reservation.end), "H':'mm"),
                format: '',
                club: detDefy.reservation.field.club?.name || '',
            });
            const time: number = Date.parse(detDefy.reservation?.start) - Date.parse(mydate.toString());
            if (time < 0) {
                setTimeDefy(true);
            } else {
                setTimeDefy(false);
            }
            //console.log({ detDefy });
            if (
                (detDefy.challengedParticipate === true && detDefy.challengedStatus === 'ACCEPTED') ||
                (detDefy.challengerParticipate === true && detDefy.challengerStatus === 'ACCEPTED')
            ) {
                setStatusDefy(true);
            }
            setTitle(`Desafío ${detDefy.challengerTeam?.name} vs ${detDefy.challengedTeam?.name}`);
            if (detDefy.challengerParticipate === false && detDefy.challengedParticipate === false) {
                //console.log('entre que no soy de este desafío');
                setParticipate(true);
            } else {
                setParticipate(false);
            }
        }
    }, [detDefy]);

    const handlerAccept = () => {
        dispatch(answerChallenge({ challengeId, challengeResponse: 'ACCEPTED' }));
    };

    const handleDecline = (value) => {
        setCancelSuscription(value);
    };

    const handleDeclineDefy = () => {
        handleDecline('inactive');
        dispatch(answerChallenge({ challengeId, challengeResponse: 'REJECTED' }));
    };

    const subTitle = '';

    return (
        <Layout navProps={{ title: 'Inscripción | Supermatch', description: 'Inscripción Supermatch' }}>
            <>
                <Header />
                <LayoutInside
                    attribute={attribute}
                    title={title}
                    subTitle={subTitle}
                    breads={breads}
                    activeIcon={false}
                >
                    {defy.isLoading ? (
                        <Loading />
                    ) : detDefy &&
                      !statusCancel &&
                      !participate &&
                      !statusDefy &&
                      !statusDecline &&
                      errorDefy === '' ? (
                        <>
                            <Defy
                                detDefy={detDefy}
                                timeDefy={timeDefy}
                                dateMatch={dateMatch}
                                sport={sport}
                                imageVs={attribute.icon.image}
                            />
                            {!timeDefy && (
                                <>
                                    {' '}
                                    {declineDefy !== 'active' && (
                                        <div
                                            className={`flex-none md:flex text-center space-x-0 md:space-x-8 justify-center content-center pt-4 md:pt-10 pb-4 md:pb-10`}
                                        >
                                            <div className="flex-1 mx-0  text-right  py-4 pt-4 pb-2 ">
                                                {/*buscar Acepto*/}
                                                <button
                                                    className={`bg-sm-rent w-full md:w-1/2 rounded-full text-white uppercase py-4 font-extrabold`}
                                                    type="button"
                                                    onClick={() => handlerAccept()}
                                                    disabled={false}
                                                >
                                                    Acepto Desafío
                                                </button>
                                            </div>
                                            <div className="flex-1 mx-0 text-left  py-4 pt-4 pb-2">
                                                {/**Button Rechazo */}
                                                <button
                                                    className={`bg-red-500  w-full md:w-1/2 rounded-full text-white uppercase py-4 font-extrabold`}
                                                    type="button"
                                                    onClick={() => handleDecline('active')}
                                                    disabled={false}
                                                >
                                                    Rechazo Desafío
                                                </button>{' '}
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}

                            {declineDefy && declineDefy === 'active' && (
                                <div className="flex-col text-center pt-1 ">
                                    <p className="text-center text-2xl font-bold italic text-red-500 pt-4 pb-2">
                                        En caso de que rechaces este desafío perderás la reserva de la cancha que
                                        tenías. <hr />
                                        ¿Estás seguro que quieres rechazar este desafío?
                                    </p>
                                    <div className="flex space-x-8 text-center w-1/2 mx-auto justify-center items-center">
                                        <button
                                            className={`${'bg-green-500'} w-20 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                            type="button"
                                            onClick={() => handleDeclineDefy()}
                                        >
                                            Si
                                        </button>
                                        <button
                                            className={`${'bg-red-500'} w-20 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                            type="button"
                                            onClick={() => handleDecline('inactive')}
                                        >
                                            No
                                        </button>
                                    </div>
                                </div>
                            )}

                            {error && !participate && (
                                <div className="flex flex-col mx-auto w-full md:w-1/3 mt-2 mb-2 text-center  font-bold">
                                    <p className="w-full my-6 text-red-500">*{error}</p>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            {participate && error && (
                                <div className="container mx-auto  flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                    <div className="w-full text-center content-center items-center">
                                        <div className={`bg-red-500  text-white uppercase py-4 font-extrabold`}>
                                            *{error}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {errorDefy && (
                                <div className="container mx-auto  flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                    <div className="w-full text-center content-center items-center">
                                        <div className={`bg-red-500  text-white uppercase py-4 font-extrabold`}>
                                            * {errorDefy}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {participate && (
                                <div className="container mx-auto  flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                    <div className="w-full text-center content-center items-center">
                                        <div className={`bg-red-500  text-white uppercase py-4 font-extrabold`}>
                                            Error este Desafío no pertecene al jugador que esta realizado la peticion
                                        </div>
                                    </div>
                                </div>
                            )}
                            {statusDefy && (
                                <MsjSuccess challengeId={challengeId}>
                                    <>
                                        <p className="pt-12 text-center text-2xl font-bold italic">
                                            Felicitaciones aceptaste el desafío
                                        </p>
                                        <p className="">_________________________</p>
                                        <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                            Pronto recibirás un correo para que realices el pago por este partido.
                                        </p>
                                        <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                            Muchas gracias!
                                        </p>
                                    </>
                                </MsjSuccess>
                            )}
                            {statusDecline && (
                                <MsjSuccess challengeId={challengeId}>
                                    <>
                                        <p className="pt-5 text-center text-2xl font-bold italic">
                                            {' '}
                                            Desafío rechazado con éxito.
                                        </p>
                                        <p className="">_________________________</p>
                                        {detDefy && detDefy.challengerParticipate === true && (
                                            <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                                La reserva de cancha que tenías para buscar rival ha sido cancelada.
                                                Para volver a reservar cancha para un partido, debes crear nuevamente un
                                                desafío.
                                            </p>
                                        )}
                                    </>
                                </MsjSuccess>
                            )}
                        </>
                    )}
                </LayoutInside>
            </>
        </Layout>
    );
};

export default Challenge;
